import { AppLayout } from '@/components/layouts/AppLayout'
import { CarsTable } from '@/components/organisms/CarsTable'

const Cars = () => {
  return (
    <AppLayout>
      <div className="space-y-6">
        <CarsTable />
      </div>
    </AppLayout>
  )
}

export default Cars
